import Vue from 'www/vue_components'
import vuetify from 'www/modules/vuetify-plugin'
import { initI18n } from 'www/utils'
import DoctorPriceBlock from 'www/vue_components/common/DoctorPriceBlockV2/DoctorPriceBlock.vue'
import DoctorPriceBlockByType from 'www/vue_components/common/DoctorPriceBlockV2/DoctorPriceBlockByType.vue'
import ClubDiscountInfo from 'src/components/common/ClubPriceInfo.vue/ClubPriceInfo.vue'

(() => {
  const clubDiscountInfoBottomSheetEl = document.querySelector('.vue-club-discount-info-bottom-sheet-mount')

  if (clubDiscountInfoBottomSheetEl) {
    new Vue({
      el: clubDiscountInfoBottomSheetEl,
      vuetify,
      render: h => h(ClubDiscountInfo),
    })
  }

  let i = 0
  const vueInstances = []

  function destroyInstances() {
    vueInstances.forEach(vm => vm.$destroy())
    vueInstances.length = 0
  }

  async function mountDoctorPriceBlock() {
    if (vueInstances.length) {
      destroyInstances()
    }

    const mountElementsByType = [...document.querySelectorAll('.vue-mount-doctor-price-block-by-type')]

    await initI18n({ bundle: 'vue_components/common/DoctorPageLpuList' })
    await initI18n({ bundle: 'vue_components/common/Club' })

    mountElementsByType.forEach(mountElement => {
      i++

      vueInstances.push(
        new Vue({
          vuetify,
          el: mountElement,
          name: `DoctorPriceBlocByTypeRoot_${i}`,
          components: {
            DoctorPriceBlockByType,
          },
        }),
      )
    })

    const mountElements = [...document.querySelectorAll('.vue-mount-doctor-price-block')]

    mountElements.forEach(mountElement => {
      i++

      vueInstances.push(
        new Vue({
          el: mountElement,
          name: `DoctorPriceBlockRoot_${i}`,
          components: {
            DoctorPriceBlock,
          },
        }),
      )
    })
  }

  window.addEventListener('mountDoctorPriceBlock', mountDoctorPriceBlock)
  mountDoctorPriceBlock()
})()
